<app-common-modal-form
  header="Ad-hoc Signing Reminders"
  icon="icon ic-bell-20"
  [isCustomFooter]="true"
  (close)="close()"
>
  <div class="body-container d-flex gap-24" [formGroup]="form">
    <div class="sent-container d-flex flex-column gap-24">
      <div class="d-flex flex-column gap-24">
        <div class="sent-container">
          <app-radio
            formControlName="sendBy"
            label="Send by"
            [options]="sendByOptions"
            (changed)="onSendByChanged($event)"
          />
        </div>

        @if (lastSendReminderDate) {
          <div class="document-container">
            <div class="debt-container">
              <div class="d-flex justify-content-between">
                <div class="font-weight-bold">Last signing reminder was sent on:</div>
                <div class="font-weight-bold">{{ lastSendReminderDate | date: 'dd/MM/yyyy' }}</div>
              </div>
            </div>
          </div>
        }
      </div>

      @if (form.controls.sendBy.value === SendOption.Email) {
        <div class="form-group">
          <app-contacts-select
            label="Recipient"
            formControlName="recipientEmails"
            [contacts]="contacts"
            (select)="onRecipientEmailChanged($event)"
          />

          @if (form.controls.recipientEmails.valid && (!selectedRecipientEmailContact?.email || !isEmailContactValid)) {
            <div class="color-red font-size-12 font-weight-400 line-height-16">
              {{ contactWithEmailRequiredMessage }}
            </div>
          }
        </div>
      } @else {
        <div class="form-group">
          <app-contacts-select
            label="Recipient"
            placeholder="Select recipient"
            formControlName="recipientPhones"
            [contacts]="contacts"
            (select)="onRecipientPhoneChanged($event)"
          />

          @if (form.controls.recipientPhones.valid && (!selectedRecipientPhonesContact?.phone || !isPhoneContactValid)) {
            <div class="color-red font-size-12 font-weight-400 line-height-16">
              {{ contactWithPhoneRequiredMessage }}
            </div>
          }
        </div>
      }
    </div>

    <div class="preview-container">
      @if (!isLoading) {
        @if (form.controls.sendBy.value === SendOption.Email && emailHtmlContent()) {
          <div class="title">Subject: {{ emailTemplate.subjectTemplate }}</div>
          <div class="preview-dashboard" [class.annual-height]="isAnnualReminder">
            <app-shadow-dom-viewer [htmlContent]="emailHtmlContent()"/>
          </div>
        } @else if (form.controls.sendBy.value == SendOption.Sms && smsHtmlContent()) {
          <div class="title">SMS Preview</div>
          <div class="sms-preview-dashboard">
            <app-shadow-dom-viewer [htmlContent]="smsHtmlContent()"/>
          </div>
        }
      } @else {
        <ngx-skeleton-loader count="2" appearance="line"/>
        <div class="d-flex gap-24">
          <ngx-skeleton-loader style="width: 50%" count="3" appearance="line"/>
          <ngx-skeleton-loader style="width: 50%" count="3" appearance="line"/>
        </div>
        <ngx-skeleton-loader count="2" appearance="line"/>
        <div class="d-flex gap-24">
          <ngx-skeleton-loader style="width: 50%" count="3" appearance="line"/>
          <ngx-skeleton-loader style="width: 50%" count="3" appearance="line"/>
        </div>
        <ngx-skeleton-loader count="2" appearance="line"/>
      }

    </div>
  </div>

  <div class="custom-footer d-flex gap-24">
    <button
      type="button"
      class="btn btn-primary d-flex align-items-center gap-2"
      [disabled]="isLoading"
      [class.btn-loading]="isLoading"
      (click)="sendReminder()"
    >
      <i class="icon ic-bell-20"></i>
      <span>Send Reminder</span>
    </button>

    <button
      type="button"
      class="btn btn-secondary d-flex align-items-center gap-2"
      [disabled]="isLoading"
      (click)="close()"
    >
      Cancel
    </button>
  </div>
</app-common-modal-form>
